/**
 * Matrix page metadata uses `show` / `hide` (also accepts legacy true/false).
 */
export function parseShowHide(value: unknown, fallback: boolean): boolean {
  if (typeof value === 'boolean') {
    return value;
  }
  const normalized = String(value ?? '')
    .trim()
    .toLowerCase();
  if (
    normalized === 'show' ||
    normalized === 'true' ||
    normalized === '1' ||
    normalized === 'yes'
  ) {
    return true;
  }
  if (
    normalized === 'hide' ||
    normalized === 'false' ||
    normalized === '0' ||
    normalized === 'no'
  ) {
    return false;
  }
  return fallback;
}
